import { EmployeeDetails } from '../services/EmployeeService'
export const userCan = (user: EmployeeDetails | null, permission: string): boolean => {
  if (user && (user.role === 'reviewer' || user.role === 'admin')) {
    return true
  }
  return false
}
